import React from 'react';
import { useFirebase } from 'react-redux-firebase';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Dropdown, Icon } from '@lionstep/ui';
import classnames from 'classnames';

import { resetAppState } from '../../../store/actions/appActions';

// Hooks
import useFilterSearchParams from '../../../hooks/useFilterSearchParams';

// Styles
import styles from './navigation.module.scss';

const NAV_LINKS = [
  { title: 'Talents', href: '/' },
  { title: 'Jobs', href: '/jobs' },
  { title: 'Matching', href: '/similar-jobs' },
];

const Navigation = () => {
  const { setFilterSearchParams } = useFilterSearchParams();
  const { pathname, state: locationState } = useLocation();
  const firebase = useFirebase();
  const dispatch = useDispatch();

  const logout = () => {
    firebase.logout();
    if (firebase.auth().currentUser) {
      firebase.ref(`presence/${firebase.auth().currentUser.uid}`).set(false);
    }
    dispatch(resetAppState());
  };

  return (
    <nav className={styles.navigation}>
      {NAV_LINKS.some(({ href }) => pathname === href) ? (
        <div className={styles.navSection}>
          <img
            src="/img/lionstep-icon-blue.svg"
            alt="Lionstep logo"
            className={styles.logo}
          />
          <span className={styles.title}>Talentpool</span>
          <ul className={styles.navLinks}>
            {NAV_LINKS.map(({ title, href }) => (
              <li
                key={href}
                className={classnames(styles.navLink, {
                  [styles.active]: pathname === href,
                })}
              >
                <Link to={href}>{title}</Link>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className={styles.navSection}>
          <button
            type="button"
            role="link"
            onClick={() => {
              setFilterSearchParams({
                filtersData: locationState?.filterSearchParams?.filtersData,
                otherData: locationState?.filterSearchParams?.otherData,
                pathname: pathname.includes('jobs') ? '/jobs' : '/',
              });
            }}
            className={styles.goBack}
          >
            <Icon name="ArrowLeft" />
            <span>Back to overview</span>
          </button>
        </div>
      )}
      <div className={styles.navSection}>
        <Dropdown
          trigger={() => <Icon name="ArrowDown" />}
          className={styles.dropdown}
        >
          <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
        </Dropdown>
      </div>
    </nav>
  );
};

export default Navigation;
